import * as signalR from '@microsoft/signalr';
export const SendWebsocketMessage = async (
    connection: signalR.HubConnection,
    message: string,
    payload?: any
) => {
    if (connection?.state === signalR.HubConnectionState.Connected) {
        if (payload) {
            await connection.send(message, payload);
        } else {
            await connection.send(message);
        }
    }
};
